import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_INIT,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_FAILED,
} from "./constants";
import { postUtil } from "../../../services/axiosClient";
import { API } from "../../../utils/Constant";
import { put, takeLatest } from "redux-saga/effects";

export function* forgetPasswordCall({ payload, onSuccessAlert, history }) {
  yield put({ type: FORGET_PASSWORD_INIT });
  try {
    const res = yield postUtil(API.forgetPassword, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: FORGET_PASSWORD_SUCCESS, data });
      onSuccessAlert();   
    } else {
      yield put({ type: FORGET_PASSWORD_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* forgetPasswordSaga() {
  yield takeLatest(FORGET_PASSWORD, forgetPasswordCall);
}
